import React, { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSelector } from 'react-redux';
import { getLocale } from '../../helpers/dates';
import { format } from 'date-fns';

import 'swiper/css';
import 'swiper/css/navigation';
import styles from './DatePickerSlider.module.css';

import ContentApp from '../ContentApp';
import Header from '../Common/Header/Header';
import Calendar from '../Common/Calendar/Calendar';
import CalendarInactiveIcon from '../../components/icons/Menu/CalendarInactiveIcon';
import ProductModal from '../Common/ProductModal/ProductModal';

const DatePickerSlider = ({
  dates,
  date,
  handleSelect,
  calendarDates = [],
  openCalendarOnClick = true,
  onCalendarClick,
}) => {
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const swiperRef = useRef(null);

  const minDateCalendar =
    calendarDates.length > 0 ? calendarDates.filter((d) => d.hasEvents)[0].date : new Date();

  const maxDateCalendar =
    calendarDates.length > 0
      ? calendarDates.filter((d) => d.hasEvents)[
          calendarDates.filter((d) => d.hasEvents).length - 1
        ].date
      : null;

  const onSelect = (d) => {
    handleSelect(d);
  };

  const onSelectCalendar = (d) => {
    const index = dates.findIndex((p) => d === format(p.date, 'yyyy-MM-dd'));
    if (index >= 0) slideToIndex(index === 0 ? 0 : index);

    setCalendarOpen(false);
    onSelect(d);
  };

  const handleCalendarClick = () => {
    openCalendarOnClick && setCalendarOpen(!calendarOpen);
    onCalendarClick?.();
  };

  const slideToIndex = (index) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index);
    }
  };

  useEffect(() => {
    if(dates.length > 0) {
      slideToIndex(dates.findIndex((p) => format(p.date, 'yyyy-MM-dd') === date));
    }
  }, [dates]);

  return (
    <>
      {dates.length > 0 && (
        <Swiper
          spaceBetween={5}
          slidesPerView={'auto'}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {dates.map((p, i) => (
            <SwiperSlide key={i}>
              <button
                onClick={() => onSelect(format(p.date, 'yyyy-MM-dd'))}
                className={[
                  styles.dateButton,
                  format(p.date, 'yyyy-MM-dd') === date && styles.selected,
                ]
                  .filter(Boolean)
                  .join(' ')}
                type='button'
                disabled={!p.hasEvents}
              >
                <div className='font-extra-small text-capitalize'>
                  {format(p.date, 'eee', { locale })}
                </div>
                <div className={styles.number}>{format(p.date, 'dd')}</div>
                <div className='font-extra-small text-capitalize'>
                  {format(p.date, 'MMM', { locale })}
                </div>
              </button>
            </SwiperSlide>
          ))}
          <SwiperSlide>
            <button
              onClick={() => handleCalendarClick()}
              className={`${styles.dateButton} `}
              type='button'
            >
              <CalendarInactiveIcon />
            </button>
          </SwiperSlide>
        </Swiper>
      )}
      <ProductModal
        open={calendarOpen}
        fullScreen
        animationClass='fade-up-horizontal'
        hasBackground
        showCloseButton={false}
      >
        <Header onClick={() => setCalendarOpen(false)} showBack />
        <ContentApp>
          <Calendar
            minDate={minDateCalendar}
            maxDate={maxDateCalendar}
            onSelectDate={(d) => onSelectCalendar(format(d, 'yyyy-MM-dd'))}
            selectedDate={date}
            className='calendar-event '
            disabledDates={calendarDates.filter((d) => !d.hasEvents).map((d) => d.date)}
          />
        </ContentApp>
      </ProductModal>
    </>
  );
};

export default DatePickerSlider;
